/**
 * 环境变量类型安全读取
 * 使用方式: import { env } from '@/utils/env'
 */

interface AppEnv {
  /** API 基础地址 */
  API_BASE_URL: string
  /** 客户扫码填写 H5 前端地址 */
  CUSTOMER_FILL_H5_BASE_URL: string
  /** Relay 模型通道基础地址；为空时新本地执行器只产生 retryable failure */
  RELAY_BASE_URL: string
  /** 是否输出 local-ai 调试原文日志 */
  LOCAL_AI_DEBUG_RAW: boolean
  /** 是否调用 v4 Shadow Context Plan；不切换当前 v3 模型输入 */
  ANALYSIS_CONTEXT_PLAN_SHADOW: boolean
  /** 是否启用 v4 Active Context Plan/Capsule 模型链路；失败时不降级到 v3 */
  ANALYSIS_CONTEXT_PLAN_ACTIVE: boolean
  /** 是否开发环境 */
  DEV: boolean
  /** 是否生产环境 */
  PROD: boolean
  /** 运行模式 */
  MODE: string
  /** 应用业务环境 */
  APP_ENV: string
}

export const env: AppEnv = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8890',
  CUSTOMER_FILL_H5_BASE_URL: import.meta.env.VITE_CUSTOMER_FILL_H5_BASE_URL || '',
  RELAY_BASE_URL:
    import.meta.env.VITE_RELAY_BASE_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    'http://127.0.0.1:8890',
  LOCAL_AI_DEBUG_RAW: import.meta.env.VITE_LOCAL_AI_DEBUG_RAW === 'true',
  ANALYSIS_CONTEXT_PLAN_SHADOW: import.meta.env.VITE_ANALYSIS_CONTEXT_PLAN_SHADOW === 'true',
  ANALYSIS_CONTEXT_PLAN_ACTIVE: import.meta.env.VITE_ANALYSIS_CONTEXT_PLAN_ACTIVE === 'true',
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
  MODE: import.meta.env.MODE,
  APP_ENV: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
}
